// Components
import {
  IntegerTableFilterDialogContent,
  TableFilterAction,
} from '@Components/shared/tables/filters';
import { TableColumnHeaderLayout } from '../TableColumnHeaderLayout';
import { SearchTableButton } from '@Components/shared/tables/actions';

// Types
import { FilterItemType } from '@Modal/reducers/types';
import { ColumnFilterable } from '@contracts/common/traits/Filterable';

type Props = {
  title: string;
  codeName?: string;
  handleSetFilters: (arg: FilterItemType) => void;
};

export const IntegerTableColumnHeader: React.FC<Props> = ({
  title,
  codeName,
  handleSetFilters,
}) => {
  return (
    <TableColumnHeaderLayout
      title={title}
      search={
        <TableFilterAction
          codeName={codeName}
          filterOptions={{}}
          buttonComponent={SearchTableButton}
          dialogComponent={IntegerTableFilterDialogContent}
          handleSetFilters={handleSetFilters}
        />
      }
    />
  );
};
